import { FiMenu } from 'react-icons/fi';
import TemaSwitch from './TemaSwitch';
import UserMenu from './UserMenu';
import TokenDebugger from '@/components/debug/TokenDebugger';
import logoRandoBR from '@/assets/RandoBR.png';

interface Props {
  mobileOpen: boolean;
  onOpenMobileMenu: () => void;
}

export default function Header({ mobileOpen, onOpenMobileMenu }: Readonly<Props>) {
  return (
    <header className="z-10 shrink-0 rounded-xl bg-surface shadow-lg">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex min-w-0 items-center gap-3">
          <button
            type="button"
            onClick={onOpenMobileMenu}
            aria-expanded={mobileOpen}
            aria-label="Abrir menu de navegação"
            className="-ml-2 rounded-lg p-2 text-ink-muted hover:bg-surface-hover hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 md:hidden"
          >
            <FiMenu size={20} />
          </button>
          {/* Mesmo chip do logo do ACP na importação: `surface-logo` não segue o
              tema, porque o azul-marinho do logo some sobre a superfície escura
              e recolorir a marca não é opção. */}
          <div className="inline-flex flex-shrink-0 rounded-lg bg-surface-logo p-1 ring-1 ring-line">
            <img src={logoRandoBR} alt="Randonneurs Brasil" className="h-10 w-auto" />
          </div>
          <h1 className="truncate text-xl font-semibold text-ink">Randonneurs Brasil Backoffice</h1>
        </div>
        <div className="flex items-center gap-1">
          {/* Ferramenta de desenvolvimento: some do bundle de produção pelo
              `import.meta.env.DEV`, e enquanto existe não disputa a tela com a
              interface — era um flutuante `z-50` no canto inferior direito. */}
          {import.meta.env.DEV && <TokenDebugger />}
          <TemaSwitch />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
